module.exports = __webpack_public_path__ + "img/red-chart.0aa1127a.svg";